import { resolveCategoryFill } from '@/features/colors/lib/paletteLookup';
import { PALETTE_COLOR_NAMES } from '@/features/colors/palettes';
import { Box, Flex, SimpleGrid, Text } from '@/ui';
import { type CardColorMode, toExperienceColorMode } from '../cardColorMode';

type Props = {
  mode: CardColorMode;
  paletteId: string | null | undefined;
};

/**
 * One sample card per palette color, showing how the palette lands at the
 * chosen fill strength. Purely a preview: aria-hidden because the segmented
 * control above is the thing to operate, and eight repetitions of the same
 * placeholder is noise to read out.
 */
export const CardGallery = ({ mode, paletteId }: Props) => (
  <Box aria-hidden layerStyle="ahCard" mt={3} p={2.5}>
    <SimpleGrid columns={2} gap={2}>
      {PALETTE_COLOR_NAMES.map((colorName) => {
        // The resolver the event cards themselves paint through, so the
        // preview cannot drift from the render.
        const { background, text } = resolveCategoryFill(
          colorName,
          paletteId,
          toExperienceColorMode(mode)
        );

        return (
          <Flex
            align="center"
            bg={background}
            borderRadius="ah-lg"
            key={colorName}
            px={3}
            py={2}
          >
            <Text
              color={text}
              fontSize="ah-status"
              fontWeight={600}
              noOfLines={1}
            >
              Example content
            </Text>
          </Flex>
        );
      })}
    </SimpleGrid>
  </Box>
);
